import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/group-young-people-working-together-project_23-2148461544.jpg';

function SNAPEligibility() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="SNAP Eligibility" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">SNAP Eligibility</h4>
              <p>
                To be eligible for SNAP benefits, households must meet certain income, resource, and other requirements. 
                The State of GTS follows federal guidelines to determine SNAP eligibility while ensuring that eligible 
                residents can access the benefits they need.
              </p>
              <div style={{ marginTop: '20px' }}>
                <a
                  href="/new_pdfs_to_load/FY2025-Income-Eligibility-Standardsv2.pdf"
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    padding: '8px 16px',
                    fontSize: '14px',
                    color: '#e75934',
                    textDecoration: 'none',
                    border: '1px solid #e75934',
                    borderRadius: '6px',
                    transition: 'all 0.2s ease',
                    backgroundColor: 'transparent',
                    width: 'fit-content'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#e75934';
                    e.currentTarget.style.color = '#fff';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.color = '#e75934';
                  }}
                >
                  <i className="fa-solid fa-file-pdf" style={{ marginRight: '8px', fontSize: '14px' }} />
                  Download FY 2025 Income Eligibility Standards (PDF)
                </a>
              </div>
            </div>

            <div className="department-details-benefits-box">
              <h3>Eligibility Requirements</h3>
              <div style={{ marginTop: '20px' }}>
                <div style={{ marginBottom: '24px' }}>
                  <h5 style={{ marginBottom: '8px', color: '#333', fontWeight: '600' }}>Income Requirements</h5>
                  <p style={{ color: '#666', marginBottom: '8px' }}>Household income must be at or below certain limits based on household size. Gross income limits are typically 130% of the federal poverty level, while net income (after deductions) must be at or below 100% of the federal poverty level.</p>
                  <a
                    href="/new_pdfs_to_load/FY2025-Income-Eligibility-Standardsv2.pdf"
                    style={{ 
                      color: '#e75934', 
                      textDecoration: 'none', 
                      fontWeight: '500', 
                      display: 'inline-flex', 
                      alignItems: 'center',
                      fontSize: '14px'
                    }}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-solid fa-file-pdf" style={{ marginRight: '6px', fontSize: '13px' }} />
                    View FY 2025 Income Eligibility Standards (PDF)
                    <i className="fa-solid fa-arrow-right" style={{ marginLeft: '5px', fontSize: '12px' }} />
                  </a>
                </div>
                <div style={{ marginBottom: '24px' }}>
                  <h5 style={{ marginBottom: '8px', color: '#333', fontWeight: '600' }}>Resource Requirements</h5>
                  <p style={{ color: '#666', marginBottom: 0 }}>Households must have limited resources (assets). Most households can have up to $2,750 in countable resources, or $4,250 if at least one member is 60 or older or disabled. Bank accounts, cash, stocks, and bonds are counted, but your home, most retirement accounts, and one vehicle are typically not counted.</p>
                </div>
                <div style={{ marginBottom: '24px' }}>
                  <h5 style={{ marginBottom: '8px', color: '#333', fontWeight: '600' }}>Work Requirements</h5>
                  <p style={{ color: '#666', marginBottom: '8px' }}>Some SNAP recipients may be subject to work requirements. Able-Bodied Adults Without Dependents (ABAWD) and Mandatory Work Participants must meet specific work requirements to maintain eligibility.</p>
                  <Link to="/department/family-services/snap/abawd" style={{ color: '#e75934', textDecoration: 'none', fontWeight: '500' }}>
                    Learn More About Work Requirements <i className="fa-solid fa-arrow-right" style={{ marginLeft: '5px' }} />
                  </Link>
                </div>
                <div style={{ marginBottom: '0' }}>
                  <h5 style={{ marginBottom: '8px', color: '#333', fontWeight: '600' }}>Citizenship and Immigration Status</h5>
                  <p style={{ color: '#666', marginBottom: 0 }}>Most SNAP recipients must be U.S. citizens or qualified non-citizens. Certain non-citizens may be eligible for SNAP benefits if they meet specific requirements.</p>
                </div>
              </div>
            </div>

            <div className="department-details-box">
              <div className="department-details-policy">
                <span>
                  Eligibility is determined based on household circumstances.
                </span>
              </div>
              <p>
                The State of GTS uses a comprehensive eligibility determination process to ensure that all eligible residents 
                can access SNAP benefits.
              </p>
            </div>

            <div className="department-details-benefits-inner-box">
              <h3>Income Deductions</h3>
              <p>
                When determining SNAP eligibility, certain deductions are allowed from your gross income, including:
              </p>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-check-circle" style={{ color: '#28a745', marginRight: '10px' }} />
                  <strong>Standard Deduction:</strong> A standard deduction based on household size
                </li>
                <li>
                  <i className="fa-solid fa-check-circle" style={{ color: '#28a745', marginRight: '10px' }} />
                  <strong>Earned Income Deduction:</strong> 20% of earned income
                </li>
                <li>
                  <i className="fa-solid fa-check-circle" style={{ color: '#28a745', marginRight: '10px' }} />
                  <strong>Child Care Deduction:</strong> Reasonable child care costs necessary for work, training, or education
                </li>
                <li>
                  <i className="fa-solid fa-check-circle" style={{ color: '#28a745', marginRight: '10px' }} />
                  <strong>Medical Expense Deduction:</strong> Out-of-pocket medical expenses for elderly or disabled household members
                </li>
                <li>
                  <i className="fa-solid fa-check-circle" style={{ color: '#28a745', marginRight: '10px' }} />
                  <strong>Shelter Deduction:</strong> Excess shelter costs (rent, mortgage, utilities) that exceed 50% of income after other deductions
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Household Composition</h4>
              <p>
                A SNAP household includes everyone who lives together and purchases and prepares meals together. 
                Household composition affects eligibility and benefit amounts.
              </p>
              <p style={{ marginTop: '15px' }}>
                <strong>Important:</strong> When applying for SNAP, you must provide information about all household members, 
                including their income, resources, and other relevant information.
              </p>
            </div>

            <div className="department-details-policy-box">
              <h4>How to Apply</h4>
              <p>
                You can apply for SNAP benefits in several ways:
              </p>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  <strong>Online:</strong> Apply through our secure online portal
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  <strong>By Mail:</strong> Download and complete the application form, then mail it to your local office
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  <strong>In Person:</strong> Visit your local Department of Family and Children Services office
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  <strong>By Phone:</strong> Call your local office to request an application be mailed to you
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Required Documentation</h4>
              <p>
                When applying for SNAP, you may need to provide the following documentation:
              </p>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Proof of identity (driver's license, state ID, or other government-issued ID)
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Proof of income (pay stubs, tax returns, benefit statements)
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Proof of expenses (rent receipts, utility bills, child care receipts)
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Proof of resources (bank statements, vehicle registration)
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Social Security numbers for all household members
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Eligibility Determination</h4>
              <p>
                After you submit your application, the Department of Family and Children Services will review your 
                information and determine your eligibility. You may be required to participate in an interview to 
                verify your information and answer any questions.
              </p>
              <p style={{ marginTop: '15px' }}>
                <strong>Processing Time:</strong> Applications are typically processed within 30 days. If you have 
                very low income and resources, you may be eligible for expedited processing within 7 days.
              </p>
            </div>

            <div>
              <Link to="/department/family-services/snap">
              <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }}/>
              Back to SNAP
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default SNAPEligibility;

